<a class="logo-wrapper" routerLink="/" [trackClick]="{ page: 'Clicked Time Doctor logo' }">
  <img class="logo" [src]="logoUrl" alt="Time Doctor logo" />
</a>
